import PaginationDto from "../Pagination.dto";
import FiltersSearchDto from "./FiltersSearch.dto";

export enum AvailableRelation {
    BRAND = 'brand',
    CATEGORY = 'category',
    LABEL = 'label',
    COLLECTION = 'collection',
    COLOR = 'color',
    GROUP_PRODUCTS = 'group_products',
    COMBINE_PRODUCTS = 'combine_products',
    INVENTORIES = 'inventories'
}

export enum AvailableSortByProperties {
    SORT_BY_PRICE_ASC = 'sort_by_price_asc',
    SORT_BY_PRICE_DESC = 'sort_by_price_desc',
    SORT_BY_RATING = 'sort_by_rating',
    SORT_BY_CREATED_AT_DESC = 'sort_by_created_at_desc'
}

export enum AvailableMeta {
    FILTERS = 'filters'
}

export interface ProductsSearchDto extends FiltersSearchDto, PaginationDto {
    search?: string;
    templates?: string[];
    sitemap_id?: string;
    color_ids?: string[];
    price_min?: number;
    price_max?: number;
    guides?: string[];
    group_master?: number;
    on_stock?: number;
    composition_ids?: string[];
    stock_variants?: string[];
    last_sync_at?: Date;
    sort_by?: AvailableSortByProperties;
    category_with_children_ids?: string[];
    exclude_ids?: string[];
    exclude_relations?: AvailableRelation[];
    exclude_meta?: AvailableMeta[];
}

export default ProductsSearchDto;